import React, { createContext, useEffect, useRef, useState } from "react";
import useCommonListFunctions, {
	CommonListFunctionsType,
	useExtendCommonListFunctions,
} from "../../../hooks/useCommonList/useCommonListFunctions";
import {
	AdminOrderManagementFilterItem,
	BookingFilterButton,
	BookingFilterTitle,
	BookingFilterWrap,
	ButtonUserWrap,
} from "../../MyBooking/styled/DesStyled";
import SearchPanel from "./SearchPanel";
import DialogAddUserAdmin from "./DialogAddUserAdmin";
import { UserFilterWrap } from "../styled/UserStyled";

export default function UserFilter(props: { reload: () => void }) {
	const {
		filterPhone,
		filterKeyword,
		doFilterPhone,
		doFilterKeyword,
		doClearFilter,
		filterBanned,
		doFilterBanned,
	} = useCommonListFunctions();
	const [isDialogLoginOpen, setIsDialogLoginOpen] = useState(false);

	const openAdd = () => {
		setIsDialogLoginOpen(true);
	};
	return (
		<UserFilterWrap>
			<BookingFilterWrap>
				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Lọc email</BookingFilterTitle>
					<SearchPanel
						placeholder="Tìm kiếm"
						filterKeyword={filterKeyword}
						doFilterKeyword={doFilterKeyword}
					/>
				</AdminOrderManagementFilterItem>

				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Lọc phone</BookingFilterTitle>
					<SearchPanel
						placeholder="Tìm kiếm"
						filterKeyword={filterPhone}
						doFilterKeyword={doFilterPhone}
					/>
				</AdminOrderManagementFilterItem>

				<AdminOrderManagementFilterItem>
					<BookingFilterTitle>Ban</BookingFilterTitle>
					<select
						style={{ minWidth: 140, padding: "6px 8px", fontSize: 13 }}
						value={
							filterBanned === "true" ? "true" : filterBanned === "false" ? "false" : ""
						}
						onChange={(e) => {
							const v = e.target.value;
							doFilterBanned?.(v === "" ? null : v);
						}}>
						<option value="">All</option>
						<option value="false">Not banned</option>
						<option value="true">Banned</option>
					</select>
				</AdminOrderManagementFilterItem>

				<DialogAddUserAdmin
					openDialog={isDialogLoginOpen}
					setOpenDialog={setIsDialogLoginOpen}
					reload={props.reload}
				/>
			</BookingFilterWrap>
			<ButtonUserWrap>
				<BookingFilterButton onClick={openAdd}>Thêm</BookingFilterButton>
			</ButtonUserWrap>
		</UserFilterWrap>
	);
}
